<template>
  <svg class="c-file-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.75 13a.75.75 0 0 0-.75-.75H9a.75.75 0 1 0 0 1.5h6a.75.75 0 0 0 .75-.75zm0 4a.75.75 0 0 0-.75-.75H9a.75.75 0 1 0 0 1.5h6a.75.75 0 0 0 .75-.75z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7 2.25A2.75 2.75 0 0 0 4.25 5v14A2.75 2.75 0 0 0 7 21.75h10A2.75 2.75 0 0 0 19.75 19V7.968c0-.381-.124-.751-.354-1.055l-2.998-3.968a1.75 1.75 0 0 0-1.396-.695H7zM5.75 5c0-.69.56-1.25 1.25-1.25h7.25v4.397c0 .414.336.75.75.75h3.25V19c0 .69-.56 1.25-1.25 1.25H7c-.69 0-1.25-.56-1.25-1.25V5z"
      :fill="color"
    />
  </svg>
</template>

<script lang="ts" setup>
withDefaults(defineProps<{ color?: string }>(), { color: '#5a5a5a' });
</script>
